import { createFileRoute, redirect } from "@tanstack/react-router";

// Fallback for Greek URLs whose translated page doesn't exist yet:
// redirect to the English equivalent instead of showing a 404.
export const Route = createFileRoute("/el/$")({
  beforeLoad: ({ params }) => {
    const splat = params._splat ?? "";
    throw redirect({ href: `/${splat}` });
  },
});
